// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__9AZ75","active":"styles_active__z5Hxu","tabContainer":"styles_tabContainer__tEnR6"};